import {
  LOADING_VARIATION,
  RECEIVE_VARIATIONS,
  VARIATION_ERROR,
  LOADING_CREATE_VARIATION,
  LOADING_EDIT_VARIATION,
  LOADING_DELETE_VARIATION,
  CREATE_VARIATION_SUCCESS,
  CREATE_VARIATION_FAILURE,
  EDIT_VARIATION_SUCCESS,
  EDIT_VARIATION_FAILURE,
  DELETE_VARIATION_SUCCESS,
  DELETE_VARIATION_FAILURE,
  FINISH_SUBMIT_VARIATION,
  FINISH_DELETE_VARIATION,
  SHOW_VARIATION_MODAL,
  CLOSE_VARIATION_MODAL,
} from './actions';

const initialState = {
  list: [],
  showCreateVariantModal: false,
  showEditVariantModal: false,
  showDeleteVariantModal: false,
  variation: {},
  isLoading: false,
  finishReceiveVariations: false,
  isDeleteVariationFinished: false,
  error: {},
  isLoadingCreate: false,
  isLoadingEdit: false,
  isLoadingDelete: false,
};

export default function variations(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_VARIATIONS:
      return {
        ...state,
        list: action.payload,
        isLoading: false,
        finishReceiveVariations: true,
      };
    case LOADING_VARIATION:
      return {
        ...state,
        isLoading: true,
      };
    case LOADING_CREATE_VARIATION:
      return {
        ...state,
        isLoadingCreate: true,
      };
    case LOADING_EDIT_VARIATION:
      return {
        ...state,
        isLoadingEdit: true,
      };
    case LOADING_DELETE_VARIATION:
      return {
        ...state,
        isLoadingDelete: true,
      };
    case VARIATION_ERROR:
      return {
        ...state,
        isLoading: false,
        isLoadingCreate: false,
        isLoadingEdit: false,
        isLoadingDelete: false,
        error: {
          ...action.error,
        },
      };
    case CREATE_VARIATION_SUCCESS:
      return {
        ...state,
        isCreateVariationFinished: true,
        isLoadingCreate: false,
      };
    case CREATE_VARIATION_FAILURE:
      return {
        ...state,
        isCreateVariationFinished: true,
        isLoadingCreate: false,
        error: {
          ...action.error,
        },
      };
    case EDIT_VARIATION_SUCCESS:
      return {
        ...state,
        isEditVariationFinished: true,
        isLoadingEdit: false,
        error: {
          ...action.error,
        },
      };
    case EDIT_VARIATION_FAILURE:
      return {
        ...state,
        isEditVariationFinished: true,
        isLoadingEdit: false,
        error: {
          ...action.error,
        },
      };
    case DELETE_VARIATION_SUCCESS:
      return {
        ...state,
        list: state.list.filter(obj => obj.id !== action.id),
        isDeleteVariationFinished: true,
        isLoadingDelete: false,
      };
    case DELETE_VARIATION_FAILURE:
      return {
        ...state,
        isDeleteVariationFinished: false,
        isLoadingDelete: false,
      };
    case FINISH_SUBMIT_VARIATION:
      return {
        ...state,
        isCreateVariationFinished: false,
        isEditVariationFinished: false,
      };
    case FINISH_DELETE_VARIATION:
      return {
        ...state,
        isDeleteVariationFinished: false,
      };
    case SHOW_VARIATION_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case CLOSE_VARIATION_MODAL:
      return {
        ...state,
        variation: {},
        showCreateVariantModal: false,
        showEditVariantModal: false,
        showDeleteVariantModal: false,
        error: {},
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/variations/reducer.js